import { useId, type ReactNode } from 'react';
import { Button } from './Button';
import './DangerZone.scss';

export interface DangerZoneItem {
  id: string;
  title: string;
  /** What will happen, so the user knows the consequence before clicking. */
  description: ReactNode;
  actionLabel: string;
  onAction: () => void;
  disabled?: boolean;
}

/**
 * Design review 2 Nov 2026 ("danger zone", as on GitHub's repository settings): the destructive actions of a page - delete,
 * disable, transfer - sit together in a red-outlined card, each with a plain consequence text and a red button.
 */
export function DangerZone({ items, title = 'Danger zone' }: { items: DangerZoneItem[]; title?: string }) {
  const headingId = useId();
  return (
    <section className="kit-danger-zone" aria-labelledby={headingId}>
      <h3 id={headingId} className="kit-danger-zone__title">
        {title}
      </h3>
      <ul className="kit-danger-zone__list">
        {items.map((item) => (
          <li key={item.id} className="kit-danger-zone__row">
            <div className="kit-danger-zone__text">
              <strong>{item.title}</strong>
              <p>{item.description}</p>
            </div>
            <Button className="kit-danger-zone__button" disabled={item.disabled} onClick={item.onAction}>
              {item.actionLabel}
            </Button>
          </li>
        ))}
      </ul>
    </section>
  );
}
